import InnerComponent from '@Components/Purchase/PurchaseOrders/BulkPoForm';
import orgContainer from '@Components/AppContainer';

const UpdateBulkPo = () => ((orgContainer(InnerComponent)));
export default UpdateBulkPo;
